import {RFPBidOptResponse, RfpCarrierBidRequestOptResponse} from '@shipwell/backend-core-sdk';

export function isShipperRfp(rfp: RFPBidOptResponse | RfpCarrierBidRequestOptResponse): rfp is RFPBidOptResponse {
  return 'state' in rfp;
}
